import { render, staticRenderFns } from "./RecoverPwOtp.vue?vue&type=template&id=3ccb0fc9&scoped=true"
import script from "./RecoverPwOtp.vue?vue&type=script&lang=js"
export * from "./RecoverPwOtp.vue?vue&type=script&lang=js"
import style0 from "./RecoverPwOtp.vue?vue&type=style&index=0&id=3ccb0fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb0fc9",
  null
  
)

export default component.exports